import _ from 'underscore';

export const staticI18nMock = {
  getString: _.identity,
  isValidDecimal: value => !_.isNaN(parseFloat(value)),
  parseDecimal: str => parseFloat(str),
  formatDecimal: float => `${float}`,
};
